"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05835 2.90976C9.05835 2.4336 9.44895 2 9.99622 2C10.5213 2 10.9417 2.40451 10.9417 2.90976V14.9036L15.3812 10.6316C15.754 10.2729 16.3476 10.2729 16.7204 10.6316C17.0932 10.9903 17.0932 11.5616 16.7204 11.9203L10.6542 17.7576L10.6377 17.7713C10.5177 17.8702 10.3778 17.9387 10.2321 17.9737L10.1644 17.99H10.1457C10.1311 17.9922 10.1135 17.9943 10.0936 17.9957C9.9535 18.0083 9.80526 17.9937 9.66307 17.9441C9.53777 17.9024 9.42748 17.8362 9.33038 17.7428L3.28744 11.9278C3.08363 11.7436 3 11.491 3 11.2796C3 11.0458 3.0988 10.8129 3.2796 10.6389C3.6524 10.2801 4.24604 10.2801 4.61883 10.6389L9.05835 14.9109V2.90976Z",
    fill: "#727B7F"
  }));
};